"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var filebar_menu_html_1 = __importDefault(require("./filebar-menu.html"));
(function (module) {
    InsertMenuController.$inject = [
        '$filter',
        'prWidgetInit',
        'prInsertMenuService',
        'prFlowingPages',
        'prMetricsService'
    ];
    function InsertMenuController($filter, widgetInit, insertMenuService, prFlowingPages, prMetricsService) {
        var $ctrl = this, translate = $filter('translate');
        angular.extend($ctrl, {
            id: 'INSERT',
            label: translate('INSERT'),
            widgetCountExceedLimitTooltip: insertMenuService.getWidgetCountExceedLimitTooltip(),
            getMenuItems: function () {
                var disablePageBreak = false;
                if ($ctrl.bdyCtrl.activePage === 0) {
                    var pages = prFlowingPages.getPages();
                    var activePageWidgets = pages[$ctrl.bdyCtrl.activePage].widgets;
                    if (!activePageWidgets.length) {
                        disablePageBreak = true;
                    }
                }
                return insertMenuService.getMenuItems(true, disablePageBreak);
            },
            selectItem: function (value) {
                if ($ctrl.bdyCtrl.activeWidgetId) {
                    // user might have scrolled after selecting a new widget
                    // update the activewidgetId if the widget is no more on the active page
                    var widgetsOnActivePage = prFlowingPages.getPages()[$ctrl.bdyCtrl.activePage].widgets;
                    var widgetFoundOnActivePage = !!_.find(widgetsOnActivePage, { '_id': $ctrl.bdyCtrl.activeWidgetId });
                    if (!widgetFoundOnActivePage) {
                        $ctrl.bdyCtrl.selectWidgets();
                    }
                }
                $ctrl.bdyCtrl.setActivePage($ctrl.bdyCtrl.activePage);
                var config;
                if (value.fieldId) { // survey data
                    config = widgetInit.getWidgetConfigFromField(value);
                    widgetInit.setWidgetInitConfig(config);
                    $ctrl.bdyCtrl.addWidgetToActivePage(config.type, false, config.sourceId, config.fieldId);
                }
                else { // add widget
                    $ctrl.bdyCtrl.addWidgetToActivePage(value);
                }
                prMetricsService.visualizationAdd(config, value, prMetricsService.CALL_SOURCE.DROPDOWN);
            },
            shouldDisableInsert: function () {
                return prFlowingPages.hasReachedWidgetLimit();
            }
        });
    }
    module.component('prInsertMenu', {
        controller: InsertMenuController,
        templateUrl: filebar_menu_html_1.default,
        require: {
            bdyCtrl: '^^prBody',
            fbCtrl: '^^prFilebar'
        }
    });
}(angular.module('qualtrics.pr')));
